import S from './SearchCategory.module.scss';
import CategoryFlag from '../CategoryFlag';
import { Dispatch, SetStateAction, useState } from 'react';
import {
  RecruitmentFilterResponseType,
  RecruitmentFilterType,
} from '../../../types/RecruitmentTypes';
import {
  fetchRecruitmentFilters,
  fetchRecruitments,
} from '../../../repository/RecruitmentRepository';
import _ from 'lodash';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UrlUtils } from '../../../utils/UrlUtils';

interface SearchCategoryProps {
  filters: RecruitmentFilterResponseType[];
  setFilters: Dispatch<SetStateAction<RecruitmentFilterResponseType[]>>;
}

const SearchCategory = (props: SearchCategoryProps) => {
  const { filters, setFilters } = props;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const queryFilters = searchParams.get('filters');
  const queryKeyword = searchParams.get('keyword');

  const handleActivateCategory = (index: number) => {
    const updatedFilters = [...filters];
    updatedFilters[index].isActive = !updatedFilters[index].isActive;
    setFilters(updatedFilters);
    const newFilters =
      updatedFilters
        .filter((filter) => filter.isActive)
        .map((f) => f.filter.id)
        .join(',') || '';
    navigate(UrlUtils.changeSearchCondition(newFilters, queryKeyword));
  };

  const resetFilters = () => {
    const updatedFilters = filters.map((filter) => ({
      ...filter,
      isActive: false,
    }));
    setFilters(updatedFilters);
    navigate(UrlUtils.changeSearchCondition('', queryKeyword));
  };

  if (filters === undefined) {
    return null;
  }

  return (
    <>
      <section className={S.search_category_section}>
        <div className={S.reset_icon_wrap}>
          <button type="button" className={S.reset_btn} onClick={() => resetFilters()}></button>
        </div>
        <div className={S.category_flag_wrap}>
          {filters?.map((filter, index) => (
            <CategoryFlag
              index={index}
              key={`category_${index}`}
              flagTitle={filter.displayName}
              isActive={filter.isActive}
              handleActivateCategory={handleActivateCategory}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default SearchCategory;
